import React from 'react';
import PropTypes from 'prop-types';
import {Input} from 'semantic-ui-react';

class FormInput extends React.Component {
  handleInputChange = (e, data) => {
    const {field, inputFields, onTextChange} = this.props;

    if (
      !data.value &&
      inputFields.type != null &&
      inputFields.type === 'number'
    )
      return;

    if (onTextChange) {
      onTextChange({...data, field});
    }
  };

  render() {
    const {inputFields, placeholder, required, value} = this.props;

    return (
      <Input
        fluid
        onChange={this.handleInputChange}
        placeholder={placeholder}
        required={required}
        value={value || value === 0 ? `${value}` : ''}
        {...inputFields}
      />
    );
  }
}

FormInput.defaultProps = {
  inputFields: {},
  placeholder: '',
  required: false,
  value: '',
};

FormInput.propTypes = {
  field: PropTypes.string.isRequired,
  inputFields: PropTypes.object,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  value: PropTypes.node,

  // functions
  onTextChange: PropTypes.func.isRequired,
};

export default FormInput;



// WEBPACK FOOTER //
// ./src/components/Common/Form/FormInput.js